import { FieldType } from "../common/constants";

export const ARTICLE_DOC = {
    fields: [
        {
            id: "picture",
            type: FieldType.ASSET,
            filter: "image/*",
            required: true,
            label: "Blog.Picture",
            localizable: false,
            picture: true,
        },
        {
            id: "title",
            type: FieldType.TEXT,
            required: true,
            label: "Blog.Title",
            width: "1/2",
            localizable: false,
            title: true,
        },
        {
            id: "description",
            type: FieldType.TEXT,
            required: true,
            label: "Courses.Description",
            localizable: false,
        },
        {
            id: "content",
            type: FieldType.HTML,
            required: true,
            label: "Blog.Content",
        },
    ],
};
